import { render } from "./lcggdytab.vue?vue&type=template&id=a0193632&scoped=true"
import script from "./lcggdytab.vue?vue&type=script&lang=js"
export * from "./lcggdytab.vue?vue&type=script&lang=js"

import "./lcggdytab.vue?vue&type=style&index=0&id=a0193632&lang=scss&scoped=true"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0193632"]])

export default __exports__